// import { useQuery } from "@tanstack/react-query";
// import axios from "axios";
// import React, { useState } from "react";
// import { useForm } from "react-hook-form";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import ReactSelect from "react-select";
// import { toast } from "react-toastify";
// import {
//   getCitiesByState,
//   getLocality,
//   getLocalityByState,
//   getServicesTypes,
//   getSingleService,
//   getStates,
//   getUnits,
//   getVehicleTypes,
// } from "../../api";
// import { api_url } from "../../constant";
// import { arrow_back } from "../../icons/arrow_back";
// import logo from "../../images/logo.png";
// import AppBar from "../../components/appBar";
// import Client from "../../utils/client";
// import ReactGA from "react-ga4";


// const AddService = ({isEdit=false, type}) => {
//   if (type === "supply") {
//     ReactGA.send({
//       hitType: "pageview",
//       page: window.location.pathname,
//       title: "Add Service Offer",
//     });
//   } else {
//     ReactGA.send({
//       hitType: "pageview",
//       page: window.location.pathname,
//       title: "Add Service Order",
//     });
//   }
//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//     watch,
//     getValues,
//     setValue,
//     reset,
//   } = useForm();
//   const navigate = useNavigate();
//   const watchAll = watch();
//   const onSubmit = (data) => post(data);
//   let { id } = useParams();

//   const { data: units } = useQuery({
//     queryKey: ["units"],
//     queryFn: () => getUnits(),
//     cacheTime: 99999,
//     staleTime: 99999,
//   });

//   const { data: states } = useQuery({
//     queryKey: ["states"],
//     queryFn: () => getStates(),
//     initialData: [],
//   });

//   const { data: services, isFetching } = useQuery({
//     queryKey: ["services"],
//     queryFn: () => getServicesTypes(),
//     initialData: [],
//   });
// //console.log(services);
//   const { data: vehicle_types } = useQuery({
//     queryKey: ["vehicle_types"],
//     queryFn: () => getVehicleTypes(),
//     initialData: [],
//   });

//   const { data: cities, refetch: citiesRefetch } = useQuery({
//     queryKey: ["cities"],
//     queryFn: () => getCitiesByState(getValues().state.value),
//     initialData: [],
//     enabled: false,
//   });
//   const { data: localities, refetch: localitiesRefetch } = useQuery({
//     queryKey: ["localities"],
//     queryFn: () => getLocalityByState(getValues().state.value),
//     initialData: [],
//     enabled: false,
//   });


//   const {} = useQuery({
//     queryKey: ["editService"],
//     queryFn: () => getSingleService(id),
//      enabled : isEdit,
//     onSuccess: (data) => {
//       reset({
//         state: { label: data._state.name, value: data._state.id },
//         city: { label: data._city.name, value: data._city.id },
//         locality: { label: data._locality.name, value: data._locality.id },

//         description: data.description,
//         service_id: {
//           label: data.service.name,
//           value: data.service.id,
//         },
//         price_per_day: data.price_per_day || null,
//         quantity: data.quantity || null,
//         type: data.type || null,
//         payload: (data.payload && data.payload.toString()) || null,
//         line: data.line || null,
//         space: data.space || null,
//         temperature: data.temperature || null,
//         height: data.height || null,
//         number_of_workers: data.number_of_workers || null,
//     });

      
//     },
//   });

//   const post = async (data) => {
//     if (!data.service_id || !data.service_id.value) {
//       toast("يرجى اختيار الخدمة", { type: "error" });
//       return;
//     }
//     if (!data.state || !data.state.value) {
//       toast("يرجى اختيار الولاية", { type: "error" });
//       return;
//     }
//     if (!data.locality || !data.locality.value) {
//       toast("يرجى اختيار المحلية", { type: "error" });
//       return;
//     }
//     // if (!data.city || !data.city.value) {
//     //   toast("يرجى اختيار المدينة", { type: "error" });
//     //   return;
//     // }

//     const _data = {
//       service_id: data.service_id.value,
//       city: data.city?.value,
//       locality: data.locality.value,
//       state: data.state.value,
//       description: data.description,
//       price_per_day: data.price_per_day || null,
//       quantity: data.quantity || null,
//       vehicle_type_id: data.vehicle_type_id?.value || null, // Renamed field
//       type: data.type || null,
//       payload: (data.payload && data.payload.toString()) || null,
//       line: data.line || null,
//       space: data.space || null,
//       temperature: data.temperature || null,
//       height: data.height || null,
//       number_of_workers: data.number_of_workers || null,
//       service_type: type,
//     };
//     if (isEdit) {
//       await Client.post(api_url + `/services/edit/${id}`, _data, {
//         headers: {
//           Authorization: "Bearer " + localStorage.getItem("token"),
//         },
//       })
//         .then((res) => window.history.go(-1))
//         .catch((e) => toast("الرجاء التأكد من البيانات", { type: "error" }));
//     } else {
//       await axios
//         .post(api_url + "/services", _data, {
//           headers: {
//             Authorization: "Bearer " + localStorage.getItem("token"),
//           },
//         })
//         .then((res) => window.history.go(-1))
//         .catch((e) => toast("الرجاء التأكد من البيانات", { type: "error" }));
//     }
//   };
//   const sold = async () => {
//     await Client.post(
//       api_url + `/services/edit/${id}`,
//       JSON.stringify({ status: "sold" }),
//       {
//         headers: {
//           Authorization: "Bearer " + localStorage.getItem("token"),
//         },
//       }
//     )
//       .then((res) => window.history.go(-1))
//       .catch((e) => toast("الرجاء التأكد من البيانات", { type: "error" }));
//   };

//   return (
//     <div className="items-center  justify-center w-screen h-screen">
//       <AppBar key="3" />
//       <div className="h-10" />
//       <div className="flex flex-row justify-between px-40 font-bold text-primary text-[18px]">
//         <div
//           className="flex justify-center items-center"
//           onClick={() => window.history.go(-1)}
//         >
//           <svg
//             className="w-7 text-primary"
//             fill="none"
//             stroke="currentColor"
//             strokeWidth={1.5}
//             viewBox="0 0 24 24"
//             xmlns="http://www.w3.org/2000/svg"
//             aria-hidden="true"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               d="M15.75 19.5L8.25 12l7.5-7.5"
//             />
//           </svg>
//           <p>العودة إلى القائمة</p>
//         </div>
//         <div className="text-black">{isEdit ? "تعديل" : "إضافة"}</div>
//       </div>
//       <div className="h-10"></div>

//       <div className="h-10"></div>
//       <div className="flex flex-col">
//         <form
//           onSubmit={handleSubmit(onSubmit)}
//           className="flex flex-col items-center justify-center gap-5"
//         >
//           <div className="flex flex-col w-2/6 lg:w-96">
//             <ReactSelect
//               options={!isFetching && services.map((e) => {
//                 return { label: e.name, value: e.id };
//               })}
//               value={getValues().service_id}
//               onChange={(value) => reset({ ...getValues(), service_id: value })}
//               hideSelectedOptions={false}
//               closeMenuOnSelect={true}
//               isRtl
//               placeholder={
//                 <span className="font-bold after:content-['*'] after:mr-1 after:text-red-500 ">
//                   الخدمة
//                 </span>
//               }
//             />
//           </div>
//           <div className="flex flex-row-reverse gap-5 w-2/6 lg:w-96">
//             <div className="w-full">
//               <ReactSelect
//                 options={states?.map((e) => {
//                   return { label: e.name, value: e.id };
//                 })}
//                 value={getValues().state}
//                 onChange={(value) => {
//                   setValue("state", value);
//                   citiesRefetch();
//                   localitiesRefetch();
//                 }}
//                 hideSelectedOptions={false}
//                 closeMenuOnSelect={true}
//                 isRtl
//                 placeholder={
//                   <span className="font-bold after:content-['*'] after:mr-1 after:text-red-500 ">
//                     الولاية
//                   </span>
//                 }
//               />
//             </div>
//             {/* <div className="w-full">
//               <ReactSelect
//                 options={cities?.map((e) => {
//                   return { label: e.name, value: e.id };
//                 })}
//                 value={getValues().city}
//                 onChange={(value) => reset({ ...getValues(), city: value })}
//                 hideSelectedOptions={false}
//                 closeMenuOnSelect={true}
//                 isRtl
//                 placeholder={
//                   <span className="font-bold after:content-['*'] after:mr-1 after:text-red-500 ">
//                     المدينة
//                   </span>
//                 }
//                 isDisabled={cities.length === 0}
//               />
//             </div> */}
//             <div className="w-full">
//               <ReactSelect
//                 options={localities?.map((e) => {
//                   return { label: e.name, value: e.id };
//                 })}
//                 value={getValues().locality}
//                 onChange={(value) => reset({ ...getValues(), locality: value })}
//                 hideSelectedOptions={false}
//                 closeMenuOnSelect={true}
//                 isRtl
//                 placeholder={
//                   <span className="font-bold after:content-['*'] after:mr-1 after:text-red-500 ">
//                     المحلية
//                   </span>
//                 }
//                 isDisabled={localities.length === 0}
//               />
//             </div>
//           </div>
//           <input
//             {...register("description")}
//             className="h-32 p-3  rounded-md w-96"
//             multiple
//             placeholder="الوصف"
//             dir="rtl"
//           />

//           {watchAll.service_id && watchAll.service_id.value === 3 && (
//             <div className="flex gap-5 w-96">
//               {/* <input {...register("type")} className="border-2 h-12 p-3  rounded-md w-full" placeholder='نوع العمالة' /> */}
//               <div className="flex flex-col w-2/6 lg:w-96">
//                 <ReactSelect
//                   options={[
//                     {
//                       label: "يومية",
//                       value: "يومية",
//                     },
//                     {
//                       label: "مقاولة",
//                       value: "مقاولة",
//                     },
//                   ]}
//                   value={{
//                     label: getValues().type ?? "نوع العمالة",
//                     value: getValues().type,
//                   }}
//                   onChange={(value) =>
//                     reset({ ...getValues(), type: value.value })
//                   }
//                   hideSelectedOptions={false}
//                   closeMenuOnSelect={true}
//                   isRtl
//                   placeholder="نوع العمالة"
//                 />
//               </div>
//               <input
//                 type="number"
//                 {...register("number_of_workers")}
//                 className="border-2 h-10 p-3  rounded-md w-full"
//                 placeholder="عدد العمال"
//               />
//             </div>
//           )}
//           {watchAll.service_id && watchAll.service_id.value === 2 && (
//             <>
//               <div className="flex gap-5 w-96">
//                 <input
//                   type="number"
//                   {...register("temperature")}
//                   className="border-2 border-gray-300 h-10 p-3  rounded-md w-full"
//                   placeholder="درجة الحرارة"
//                 />
//                 {/* <input {...register("type")} className="border-2 h-12 p-3  rounded-md w-full" placeholder='نوع المخزن' /> */}
//                 <div className="flex flex-col w-2/6 lg:w-96">
//                   <ReactSelect
//                     options={[
//                       {
//                         label: "جاف",
//                         value: "جاف",
//                       },
//                       {
//                         label: "مبرد",
//                         value: "مبرد",
//                       },
//                     ]}
//                     value={{
//                       label: getValues().type ?? "نوع المخزن",
//                       value: getValues().type,
//                     }}
//                     onChange={(value) =>
//                       reset({ ...getValues(), type: value.value })
//                     }
//                     hideSelectedOptions={false}
//                     closeMenuOnSelect={true}
//                     isRtl
//                     placeholder="نوع المخزن"
//                   />
//                 </div>
//               </div>
//               <div className="flex gap-5 w-96">
//                 <input
//                   {...register("height")}
//                   className="border-2 h-12 p-3 rounded-md w-full"
//                   placeholder="الإرتفاع م"
//                 />
//                 <input
//                   {...register("space")}
//                   className="border-2 h-12 p-3  rounded-md w-full"
//                   placeholder="المساحة م"
//                 />
//               </div>
//             </>
//           )}
//           {watchAll.service_id && watchAll.service_id.value === 1 && (
//             <>
//               <div className="flex flex-row-reverse gap-5 w-2/6 lg:w-96">
//                 <div className="flex flex-col w-2/6 lg:w-96">
//                   <ReactSelect
//                     options={vehicle_types?.map((e) => {
//                       return {
//                         label: e.name + " " + e.payload + "",
//                         value: e.id,
//                       };
//                     })}
//                     value={getValues().vehicle_type_id}
//                     onChange={(value) => reset({ ...getValues(), vehicle_type_id: value })}
//                     hideSelectedOptions={false}
//                     closeMenuOnSelect={true}
//                     isRtl
//                     placeholder="نوع المركبة"
//                   />
//                 </div>
//                 <div className="flex flex-col w-2/6 lg:w-96">
//                   <ReactSelect
//                     options={[
//                       {
//                         label: "محلي",
//                         value: "محلي",
//                       },
//                       {
//                         label: "ولائي",
//                         value: "ولائي",
//                       },
//                     ]}
//                     value={{
//                       label: getValues().line ?? "خط النقل",
//                       value: getValues().line,
//                     }}
//                     onChange={(value) =>
//                       reset({ ...getValues(), line: value.value })
//                     }
//                     hideSelectedOptions={false}
//                     closeMenuOnSelect={true}
//                     isRtl
//                     placeholder="خط النقل"
//                   />
//                 </div>
//               </div>

//               <div className="flex gap-5 w-96">
//                 <div className="flex flex-col w-2/6 lg:w-96">
//                   <ReactSelect
//                     options={units.map((e) => {
//                       return { label: e.name, value: e.name };
//                     })}
//                     value={{
//                       label: getValues().quantity ?? "الوحدة",
//                       value: getValues().quantity,
//                     }}
//                     onChange={(value) =>
//                       reset({ ...getValues(), quantity: value.value })
//                     }
//                     hideSelectedOptions={false}
//                     closeMenuOnSelect={true}
//                     isRtl
//                     placeholder="الوحدة"
//                   />
//                 </div>

//                 {/* <input {...register("quantity")} className="border-2 h-12 p-3  rounded-md w-full" placeholder='الوحدة' /> */}
//                 <input
//                   type="number"
//                   min="1"
//                   {...register("payload", {
//                     valueAsNumber: true,
//                     validate: (value) => value > 0,
//                   })}
//                   className="border-[1px] border-gray-400 h-10 p-3  rounded-md w-full"
//                   placeholder="الحمولة"
//                 />
//               </div>
//             </>
//           )}
//           <button
//             hidden={!isEdit}
//             type="button"
//             {...register("status")}
//             className="border-2 h-12 p-3  rounded-md w-60 bg-amber-600 text-white font-bold text-lg"
//             value="تم البيع؟"
//             onClick={() => sold()}
//           >
//             تم البيع؟
//           </button>
//           <input
//             type="submit"
//             className="h-12 bg-primary text-white rounded-md w-60"
//             value={isEdit ? "تعديل" : "إضافه"}
//           />
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AddService;
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import {
  getCitiesByState,
  getLocality,
  getLocalityByState,
  getServicesTypes,
  getSingleService,
  getStates,
  getUnits,
  getVehicleTypes,
} from "../../api";
import { api_url } from "../../constant";
import { arrow_back } from "../../icons/arrow_back";
import logo from "../../images/logo.png";
import AppBar from "../../components/appBar";
import Client from "../../utils/client";
import ReactGA from "react-ga4";

const AddService = ({ isEdit = false, type }) => {
  const { t, i18n } = useTranslation();
  
  if (type === "supply") {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "Add Service Offer",
    });
  } else {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "Add Service Order",
    });
  }
  
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    getValues,
    setValue,
    reset,
  } = useForm();
  
  const navigate = useNavigate();
  const watchAll = watch();
  const onSubmit = (data) => post(data);
  let { id } = useParams();

  const { data: units } = useQuery({
    queryKey: ["units"],
    queryFn: () => getUnits(),
    cacheTime: 99999,
    staleTime: 99999,
  });

  const { data: states } = useQuery({
    queryKey: ["states"],
    queryFn: () => getStates(),
    initialData: [],
  });

  const { data: services, isFetching } = useQuery({
    queryKey: ["services"],
    queryFn: () => getServicesTypes(),
    initialData: [],
  });

  const { data: vehicle_types } = useQuery({
    queryKey: ["vehicle_types"],
    queryFn: () => getVehicleTypes(),
    initialData: [],
  });

  const { data: cities, refetch: citiesRefetch } = useQuery({
    queryKey: ["cities"],
    queryFn: () => getCitiesByState(getValues().state.value),
    initialData: [],
    enabled: false,
  });
  
  const { data: localities, refetch: localitiesRefetch } = useQuery({
    queryKey: ["localities"],
    queryFn: () => getLocalityByState(getValues().state.value),
    initialData: [],
    enabled: false,
  });

  const {} = useQuery({
    queryKey: ["editService"],
    queryFn: () => getSingleService(id),
    enabled: isEdit,
    onSuccess: (data) => {
      reset({
        state: { label: data._state.name, value: data._state.id },
        city: { label: data._city.name, value: data._city.id },
        locality: { label: data._locality.name, value: data._locality.id },
        description: data.description,
        service_id: {
          label: data.service.name,
          value: data.service.id,
        },
        price_per_day: data.price_per_day || null,
        quantity: data.quantity || null,
        type: data.type || null,
        payload: (data.payload && data.payload.toString()) || null,
        line: data.line || null,
        space: data.space || null,
        temperature: data.temperature || null,
        height: data.height || null,
        number_of_workers: data.number_of_workers || null,
      });
    },
  });

  const post = async (data) => {
    if (!data.service_id || !data.service_id.value) {
      toast(t("addService.errors.noService"), { type: "error" });
      return;
    }
    if (!data.state || !data.state.value) {
      toast(t("addService.errors.noState"), { type: "error" });
      return;
    }
    if (!data.locality || !data.locality.value) {
      toast(t("addService.errors.noLocality"), { type: "error" });
      return;
    }

    const _data = {
      service_id: data.service_id.value,
      city: data.city?.value,
      locality: data.locality.value,
      state: data.state.value,
      description: data.description,
      price_per_day: data.price_per_day || null,
      quantity: data.quantity || null,
      vehicle_type_id: data.vehicle_type_id?.value || null,
      type: data.type || null,
      payload: (data.payload && data.payload.toString()) || null,
      line: data.line || null,
      space: data.space || null,
      temperature: data.temperature || null,
      height: data.height || null,
      number_of_workers: data.number_of_workers || null,
      service_type: type,
    };
    
    if (isEdit) {
      await Client.post(api_url + `/services/edit/${id}`, _data, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((res) => window.history.go(-1))
        .catch((e) => toast(t("addService.errors.checkData"), { type: "error" }));
    } else {
      await axios
        .post(api_url + "/services", _data, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((res) => window.history.go(-1))
        .catch((e) => toast(t("addService.errors.checkData"), { type: "error" }));
    }
  };
  
  const sold = async () => {
    await Client.post(
      api_url + `/services/edit/${id}`,
      JSON.stringify({ status: "sold" }),
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((res) => window.history.go(-1))
      .catch((e) => toast(t("addService.errors.checkData"), { type: "error" }));
  };

  return (
    <div className="items-center justify-center w-screen h-screen">
      <AppBar key="3" />
      <div className="h-10" />
      <div className="flex flex-row justify-between px-40 font-bold text-primary text-[18px]">
        <div
          className="flex justify-center items-center cursor-pointer"
          onClick={() => window.history.go(-1)}
        >
          <svg
            className="w-7 text-primary"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.5}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15.75 19.5L8.25 12l7.5-7.5"
            />
          </svg>
          <p>{t("addService.backToList")}</p>
        </div>
        <div className="text-black">{isEdit ? t("addService.edit") : t("addService.add")}</div>
      </div>
      <div className="h-10"></div>
      <div className="h-10"></div>
      
      <div className="flex flex-col">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex flex-col items-center justify-center gap-5"
        >
          <div className="flex flex-col w-2/6 lg:w-96">
            <ReactSelect
              options={!isFetching && services.map((e) => {
                return { label: e.name, value: e.id };
              })}
              value={getValues().service_id}
              onChange={(value) => reset({ ...getValues(), service_id: value })}
              hideSelectedOptions={false}
              closeMenuOnSelect={true}
              isRtl={i18n.language === 'ar'}
              placeholder={
                <span className="font-bold after:content-['*'] after:mr-1 after:text-red-500">
                  {t("addService.placeholders.service")}
                </span>
              }
            />
          </div>
          
          <div className="flex flex-row-reverse gap-5 w-2/6 lg:w-96">
            <div className="w-full">
              <ReactSelect
                options={states?.map((e) => {
                  return { label: e.name, value: e.id };
                })}
                value={getValues().state}
                onChange={(value) => {
                  setValue("state", value);
                  citiesRefetch();
                  localitiesRefetch();
                }}
                hideSelectedOptions={false}
                closeMenuOnSelect={true}
                isRtl={i18n.language === 'ar'}
                placeholder={
                  <span className="font-bold after:content-['*'] after:mr-1 after:text-red-500">
                    {t("addService.placeholders.state")}
                  </span>
                }
              />
            </div>
            <div className="w-full">
              <ReactSelect
                options={localities?.map((e) => {
                  return { label: e.name, value: e.id };
                })}
                value={getValues().locality}
                onChange={(value) => reset({ ...getValues(), locality: value })}
                hideSelectedOptions={false}
                closeMenuOnSelect={true}
                isRtl={i18n.language === 'ar'}
                placeholder={
                  <span className="font-bold after:content-['*'] after:mr-1 after:text-red-500">
                    {t("addService.placeholders.locality")}
                  </span>
                }
                isDisabled={localities.length === 0}
              />
            </div>
          </div>
          
          <input
            {...register("description")}
            className="h-32 p-3 rounded-md w-96"
            multiple
            placeholder={t("addService.placeholders.description")}
            dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
          />

          {watchAll.service_id && watchAll.service_id.value === 3 && (
            <div className="flex gap-5 w-96">
              <div className="flex flex-col w-2/6 lg:w-96">
                <ReactSelect
                  options={[
                    { label: t("addService.laborTypes.daily"), value: "يومية" },
                    { label: t("addService.laborTypes.contract"), value: "مقاولة" },
                  ]}
                  value={{
                    label: getValues().type ?? t("addService.laborTypes.laborType"),
                    value: getValues().type,
                  }}
                  onChange={(value) => reset({ ...getValues(), type: value.value })}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={true}
                  isRtl={i18n.language === 'ar'}
                  placeholder={t("addService.laborTypes.laborType")}
                />
              </div>
              <input
                type="number"
                {...register("number_of_workers")}
                className="border-2 h-10 p-3 rounded-md w-full"
                placeholder={t("addService.placeholders.numberOfWorkers")}
                dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
              />
            </div>
          )}
          
          {watchAll.service_id && watchAll.service_id.value === 2 && (
            <>
              <div className="flex gap-5 w-96">
                <input
                  type="number"
                  {...register("temperature")}
                  className="border-2 border-gray-300 h-10 p-3 rounded-md w-full"
                  placeholder={t("addService.placeholders.temperature")}
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                />
                <div className="flex flex-col w-2/6 lg:w-96">
                  <ReactSelect
                    options={[
                      { label: t("addService.storageTypes.dry"), value: "جاف" },
                      { label: t("addService.storageTypes.cooled"), value: "مبرد" },
                    ]}
                    value={{
                      label: getValues().type ?? t("addService.storageTypes.storageType"),
                      value: getValues().type,
                    }}
                    onChange={(value) => reset({ ...getValues(), type: value.value })}
                    hideSelectedOptions={false}
                    closeMenuOnSelect={true}
                    isRtl={i18n.language === 'ar'}
                    placeholder={t("addService.storageTypes.storageType")}
                  />
                </div>
              </div>
              <div className="flex gap-5 w-96">
                <input
                  {...register("height")}
                  className="border-2 h-12 p-3 rounded-md w-full"
                  placeholder={t("addService.placeholders.height")}
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                />
                <input
                  {...register("space")}
                  className="border-2 h-12 p-3 rounded-md w-full"
                  placeholder={t("addService.placeholders.space")}
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                />
              </div>
            </>
          )}
          
          {watchAll.service_id && watchAll.service_id.value === 1 && (
            <>
              <div className="flex flex-row-reverse gap-5 w-2/6 lg:w-96">
                <div className="flex flex-col w-2/6 lg:w-96">
                  <ReactSelect
                    options={vehicle_types?.map((e) => {
                      return {
                        label: e.name + " " + e.payload + "",
                        value: e.id,
                      };
                    })}
                    value={getValues().vehicle_type_id}
                    onChange={(value) => reset({ ...getValues(), vehicle_type_id: value })}
                    hideSelectedOptions={false}
                    closeMenuOnSelect={true}
                    isRtl={i18n.language === 'ar'}
                    placeholder={t("addService.placeholders.vehicleType")}
                  />
                </div>
                <div className="flex flex-col w-2/6 lg:w-96">
                  <ReactSelect
                    options={[
                      { label: t("addService.transportLines.local"), value: "محلي" },
                      { label: t("addService.transportLines.state"), value: "ولائي" },
                    ]}
                    value={{
                      label: getValues().line ?? t("addService.transportLines.transportLine"),
                      value: getValues().line,
                    }}
                    onChange={(value) => reset({ ...getValues(), line: value.value })}
                    hideSelectedOptions={false}
                    closeMenuOnSelect={true}
                    isRtl={i18n.language === 'ar'}
                    placeholder={t("addService.transportLines.transportLine")}
                  />
                </div>
              </div>

              <div className="flex gap-5 w-96">
                <div className="flex flex-col w-2/6 lg:w-96">
                  <ReactSelect
                    options={units.map((e) => {
                      return { label: e.name, value: e.name };
                    })}
                    value={{
                      label: getValues().quantity ?? t("addService.placeholders.unit"),
                      value: getValues().quantity,
                    }}
                    onChange={(value) => reset({ ...getValues(), quantity: value.value })}
                    hideSelectedOptions={false}
                    closeMenuOnSelect={true}
                    isRtl={i18n.language === 'ar'}
                    placeholder={t("addService.placeholders.unit")}
                  />
                </div>
                <input
                  type="number"
                  min="1"
                  {...register("payload", {
                    valueAsNumber: true,
                    validate: (value) => value > 0,
                  })}
                  className="border-[1px] border-gray-400 h-10 p-3 rounded-md w-full"
                  placeholder={t("addService.placeholders.payload")}
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                />
              </div>
            </>
          )}
          
          <button
            hidden={!isEdit}
            type="button"
            {...register("status")}
            className="border-2 h-12 p-3 rounded-md w-60 bg-amber-600 text-white font-bold text-lg"
            onClick={() => sold()}
          >
            {t("addService.soldButton")}
          </button>
          
          <input
            type="submit"
            className="h-12 bg-primary text-white rounded-md w-60 cursor-pointer"
            value={isEdit ? t("addService.edit") : t("addService.add")}
          />
        </form>
      </div>
    </div>
  );
};

export default AddService;